<template>
    <div>
      <v-row>
        <v-col
          cols="12"
          md="6">
          <v-card
            flat
            class="mb-6"
            style="border: 2px dashed #e0e0e0; border-radius: 10px;">
            <v-card-text>
              <ValidationProvider 
                name="Nomor Surat" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Nomor Surat
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  
                  placeholder="Contoh. SRT/PRK/20240102/0001"
                  hide-details
  
                  v-model="form.number"
                  :success="valid"
                  :error-messages="errors"
                  required
                  class="mb-6"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Nomor Surat {{ errors[0] }}
                      </v-tooltip>
                    </div>
  
                    <div v-if="form.number !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
  
              <ValidationProvider 
                name="Tujuan Penerima" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Tujuan Penerima
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  
                  placeholder="Contoh. John Doe"
                  hide-details
  
                  v-model="form.for"
                  :success="valid"
                  :error-messages="errors"
                  required
                  class="mb-3"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Tujuan Penerima {{ errors[0] }}
                      </v-tooltip>
                    </div>
  
                    <div v-if="form.for !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-card-text>
          </v-card>
  
          <ValidationProvider 
            name="Nama File" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Nama File
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Surat Menyurat"
              hide-details
  
              v-model="form.title"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Nama File {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.title !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
  
          <ValidationProvider 
            name="Nomor" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Nomor
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. 005/PT.UMB/IV/2022"
              hide-details
  
              v-model="form.template_meta_json_object.nomor"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px; width: 70%;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Nomor {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.nomor !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>

          <v-row>
            <v-col
              cols="12"
              md="5"
              class="py-0">
              <div>
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Tanggal Acara
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
  
                <v-menu
                  ref="hari_tanggal"
                  min-width="290px"
                  max-width="290px"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  :close-on-content-click="false"
                  v-model="picker.tanggal_mulai">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider 
                      name="Tanggal Acara" 
                      rules="required"
                      v-slot="{ errors, valid }">
                      <v-text-field
                        readonly
                        filled
                        rounded
                        dense
                        :color="set_color"
                        placeholder="Pilih Tanggal"
                        hide-details
                        clearable
  
                        @click:clear="form.template_meta_json_object.hari_tanggal = null;"
                        v-on="on"
                        v-bind="attrs"
  
                        v-model="form.template_meta_json_object.hari_tanggal"
                        :success="form.template_meta_json_object.hari_tanggal !== null && valid"
                        :error-messages="errors"
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Tanggal Acara {{ errors[0] }}
                            </v-tooltip>
                          </div>
  
                          <div v-if="form.template_meta_json_object.hari_tanggal !== null && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </template>
  
                  <v-date-picker 
                    :color="set_color"
                    v-model="form.template_meta_json_object.hari_tanggal"
                    @input="picker.tanggal_mulai = false">
                  </v-date-picker>
                </v-menu>
              </div>
            </v-col>
          </v-row>
  
          <ValidationProvider 
            name="Nama Acara" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Nama Acara
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Rapat"
              hide-details
  
              v-model="form.template_meta_json_object.acara"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px; width: 50%;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Nama Acara {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.acara !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
  
          <ValidationProvider 
            name="Tempat Acara" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Tempat Acara
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Gedung PT. UMB"
              hide-details
  
              v-model="form.template_meta_json_object.tempat"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px; width: 70%;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Tempat Acara {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.tempat !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>

          <v-row>
            <v-col
              cols="12"
              md="5"
              class="py-0">
              <div>
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Waktu Pembukaan
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-menu
                  ref="pukul"
                  v-model="time.pukul"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="form.template_meta_json_object.pukul"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider 
                      name="Waktu Pembukaan" 
                      rules="required"
                      v-slot="{ errors, valid }">
                      <v-text-field
                        readonly
                        
                        filled
                        rounded
                        dense
                        :color="set_color"
                        placeholder="Contoh. 09:00"
                        hide-details

                        clearable
                        @click:clear="form.template_meta_json_object.pukul = null"
                        v-on="on"
                        v-bind="attrs"

                        v-model="form.template_meta_json_object.pukul"
                        :success="valid"
                        :error-messages="errors"
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Waktu Pembukaan {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.pukul !== null && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </template>

                  <v-time-picker
                    v-if="time.pukul"
                    v-model="form.template_meta_json_object.pukul"
                    full-width
                    :color="set_color"
                    format="24hr"
                    @click:minute="$refs.pukul.save(`${form.template_meta_json_object.pukul}`);">
                  </v-time-picker>
                </v-menu>
              </div>
            </v-col>
          </v-row>
  
          <ValidationProvider 
            name="Pembukaan oleh" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Pembukaan oleh
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Pembukaan oleh."
              hide-details
  
              v-model="form.template_meta_json_object.pembuka"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Pembukaan oleh {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.pembuka !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
  
          <ValidationProvider 
            name="Keteraan Pembukaan" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Keteraan Pembukaan
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Keteraan Pembukaan."
              hide-details
  
              v-model="form.template_meta_json_object.keterangan"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Keteraan Pembukaan {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.keterangan !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
  
          <v-btn
            @click="add_hadir()"
  
            color="#444444"
            elevation="0"
            class="text-capitalize white--text mb-4"
            style="border-radius: 10px;">
            Tambah Daftar Hadir
          </v-btn>
  
          <div
            v-for="(item, index) in form.template_meta_json_object.hadir"
            :key="index">
            <v-card
              flat
              class="pa-3 mb-6"
              style="border: 2px dashed #f0f0f0; border-radius: 10px;">
              <v-btn
                @click="form.template_meta_json_object.hadir.splice(index, 1)"
  
                icon
                style="position: absolute; top: -15px; right: -15px;">
                <v-icon
                  color="red">
                  mdi-close-circle
                </v-icon>
              </v-btn>
  
              <ValidationProvider 
                name="Nama" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Nama
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  
                  placeholder="Contoh. Nama"
                  hide-details
  
                  v-model="item.nama"
                  :success="valid"
                  :error-messages="errors"
                  required
                  class="mb-6"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Nama {{ errors[0] }}
                      </v-tooltip>
                    </div>
  
                    <div v-if="item.nama !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
  
              <ValidationProvider 
                name="Jabatan" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Jabatan
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  
                  placeholder="Contoh. 10"
                  hide-details
  
                  v-model="item.jabatan"
                  :success="valid"
                  :error-messages="errors"
                  required
                  class="mb-6"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Jabatan {{ errors[0] }}
                      </v-tooltip>
                    </div>
  
                    <div v-if="item.jabatan !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
  
              <ValidationProvider
                name="Unit" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Unit
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-autocomplete
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  placeholder="Contoh. UMB Boga"

                  :loading="process.unit"
                  
                  :items="units"
                  item-value="name"
                  item-text="name"
                  :item-color="set_color"

                  v-model="item.unit"
                  :success="item.unit !== '' && valid"
                  :error-messages="errors"
                  required
                  class="mb-6"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Unit {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="item.unit !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-autocomplete>
              </ValidationProvider>
  
            </v-card>
          </div>

          
          <v-btn
            @click="add_agenda()"
  
            color="#444444"
            elevation="0"
            class="text-capitalize white--text mb-4"
            style="border-radius: 10px;">
            Tambah Agenda
          </v-btn>
  
          <div
            v-for="(item, index) in form.template_meta_json_object.agenda"
            :key="index">
            <v-card
              flat
              class="pa-3 mb-6"
              style="border: 2px dashed #f0f0f0; border-radius: 10px;">
              <v-btn
                @click="form.template_meta_json_object.agenda.splice(index, 1)"
  
                icon
                style="position: absolute; top: -15px; right: -15px;">
                <v-icon
                  color="red">
                  mdi-close-circle
                </v-icon>
              </v-btn>
  
              <ValidationProvider 
                name="Agenda" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Agenda
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  
                  placeholder="Contoh. Agenda"
                  hide-details
  
                  v-model="item.text"
                  :success="valid"
                  :error-messages="errors"
                  required
                  class="mb-6"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Agenda {{ errors[0] }}
                      </v-tooltip>
                    </div>
  
                    <div v-if="item.text !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
  
            </v-card>
          </div>

          <v-btn
            @click="add_pembahasan()"
  
            color="#444444"
            elevation="0"
            class="text-capitalize white--text mb-4"
            style="border-radius: 10px;">
            Tambah Pembahasan
          </v-btn>
  
          <div
            v-for="(item, index) in form.template_meta_json_object.pembahasan"
            :key="index">
            <v-card
              flat
              class="pa-3 mb-6"
              style="border: 2px dashed #f0f0f0; border-radius: 10px;">
              <v-btn
                @click="form.template_meta_json_object.pembahasan.splice(index, 1)"
  
                icon
                style="position: absolute; top: -15px; right: -15px;">
                <v-icon
                  color="red">
                  mdi-close-circle
                </v-icon>
              </v-btn>
  
              <ValidationProvider 
                name="Pembahasan" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Pembahasan
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  
                  placeholder="Contoh. Pembahasan"
                  hide-details
  
                  v-model="item.text"
                  :success="valid"
                  :error-messages="errors"
                  required
                  class="mb-6"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Pembahasan {{ errors[0] }}
                      </v-tooltip>
                    </div>
  
                    <div v-if="item.text !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="Pembicara" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Pembicara
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  
                  placeholder="Contoh. Pembicara"
                  hide-details
  
                  v-model="item.pembicara"
                  :success="valid"
                  :error-messages="errors"
                  required
                  class="mb-6"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Pembicara {{ errors[0] }}
                      </v-tooltip>
                    </div>
  
                    <div v-if="item.pembicara !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="Ringkasan" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Ringkasan
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  
                  placeholder="Contoh. Ringkasan"
                  hide-details
  
                  v-model="item.ringkasan"
                  :success="valid"
                  :error-messages="errors"
                  required
                  class="mb-6"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Ringkasan {{ errors[0] }}
                      </v-tooltip>
                    </div>
  
                    <div v-if="item.ringkasan !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
  
            </v-card>
          </div>

          <v-btn
            @click="add_kesimpulan()"
  
            color="#444444"
            elevation="0"
            class="text-capitalize white--text mb-4"
            style="border-radius: 10px;">
            Tambah Kesimpulan
          </v-btn>
  
          <div
            v-for="(item, index) in form.template_meta_json_object.kesimpulan"
            :key="index">
            <v-card
              flat
              class="pa-3 mb-6"
              style="border: 2px dashed #f0f0f0; border-radius: 10px;">
              <v-btn
                @click="form.template_meta_json_object.kesimpulan.splice(index, 1)"
  
                icon
                style="position: absolute; top: -15px; right: -15px;">
                <v-icon
                  color="red">
                  mdi-close-circle
                </v-icon>
              </v-btn>
  
              <ValidationProvider 
                name="Kesimpulan" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Kesimpulan
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  
                  placeholder="Contoh. Kesimpulan"
                  hide-details
  
                  v-model="item.text"
                  :success="valid"
                  :error-messages="errors"
                  required
                  class="mb-6"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Kesimpulan {{ errors[0] }}
                      </v-tooltip>
                    </div>
  
                    <div v-if="item.text !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
  
            </v-card>
          </div>


          <v-row>
            <v-col
              cols="12"
              md="5"
              class="py-0">
              <div>
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Waktu Penutupan
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-menu
                  ref="pukul_tutup"
                  v-model="time.pukul_tutup"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="form.template_meta_json_object.pukul_tutup"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider 
                      name="Waktu Penutupan" 
                      rules="required"
                      v-slot="{ errors, valid }">
                      <v-text-field
                        readonly
                        
                        filled
                        rounded
                        dense
                        :color="set_color"
                        placeholder="Contoh. 09:00"
                        hide-details

                        clearable
                        @click:clear="form.template_meta_json_object.pukul_tutup = null"
                        v-on="on"
                        v-bind="attrs"

                        v-model="form.template_meta_json_object.pukul_tutup"
                        :success="valid"
                        :error-messages="errors"
                        class="mb-6"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Waktu Penutupan {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.template_meta_json_object.pukul_tutup !== null && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </template>

                  <v-time-picker
                    v-if="time.pukul_tutup"
                    v-model="form.template_meta_json_object.pukul_tutup"
                    full-width
                    :color="set_color"
                    format="24hr"
                    @click:minute="$refs.pukul_tutup.save(`${form.template_meta_json_object.pukul_tutup}`);">
                  </v-time-picker>
                </v-menu>
              </div>
            </v-col>
          </v-row>
  
          <ValidationProvider 
            name="Penutupan oleh" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Penutupan oleh
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Penutupan oleh."
              hide-details
  
              v-model="form.template_meta_json_object.penutup"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Penutupan oleh {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.penutup !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
  
          <ValidationProvider 
            name="Keteraan Penutupan" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Keteraan Penutupan
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Keteraan Penutupan."
              hide-details
  
              v-model="form.template_meta_json_object.keterangan_tutup"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Keteraan Penutupan {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.keterangan_tutup !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
  
          <ValidationProvider 
            name="Nama Yang Bertandatangan" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Nama Yang Bertandatangan
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Dr. Alni Rahmawati, SE., MM."
              hide-details
  
              v-model="form.template_meta_json_object.nama_1"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Nama Yang Bertandatangan {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.nama_1 !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
  
          <ValidationProvider 
            name="Jabatan Yang Bertandatangan" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Jabatan Yang Bertandatangan
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Direktur Utama PT.UMB."
              hide-details
  
              v-model="form.template_meta_json_object.jabatan_1"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-3"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Jabatan Yang Bertandatangan {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.jabatan_1 !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
  
          <div>
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Tanggal
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
  
            <v-menu
              ref="tanggal"
              min-width="290px"
              max-width="290px"
              transition="scale-transition"
              offset-y
              :nudge-right="40"
              :close-on-content-click="false"
              v-model="picker.tanggal">
              <template v-slot:activator="{ on, attrs }">
                <ValidationProvider 
                  name="Tanggal" 
                  rules="required"
                  v-slot="{ errors, valid }">
                  <v-text-field
                    readonly
                    filled
                    rounded
                    dense
                    :color="set_color"
                    placeholder="Pilih Tanggal"
                    hide-details
                    clearable
  
                    @click:clear="form.template_meta_json_object.tanggal = null;"
                    v-on="on"
                    v-bind="attrs"
  
                    v-model="form.template_meta_json_object.tanggal"
                    :success="form.template_meta_json_object.tanggal !== null && valid"
                    :error-messages="errors"
                    class="mb-6"
                    style="border-radius: 10px; width: 40%;">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          Tanggal {{ errors[0] }}
                        </v-tooltip>
                      </div>
  
                      <div v-if="form.template_meta_json_object.tanggal !== null && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </template>
  
              <v-date-picker 
                :color="set_color"
                v-model="form.template_meta_json_object.tanggal"
                @input="picker.tanggal = false">
              </v-date-picker>
            </v-menu>
          </div>

          <v-btn
            @click="add_tembusan()"
  
            color="#444444"
            elevation="0"
            class="text-capitalize white--text mb-4"
            style="border-radius: 10px;">
            Tambah Tembusan
          </v-btn>
  
          <div
            v-for="(item, index) in form.template_meta_json_object.tembusan"
            :key="index">
            <v-card
              flat
              class="pa-3 mb-6"
              style="border: 2px dashed #f0f0f0; border-radius: 10px;">
              <v-btn
                @click="form.template_meta_json_object.tembusan.splice(index, 1)"
  
                icon
                style="position: absolute; top: -15px; right: -15px;">
                <v-icon
                  color="red">
                  mdi-close-circle
                </v-icon>
              </v-btn>
  
              <ValidationProvider 
                name="Tembusan" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Tembusan
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  
                  placeholder="Contoh. Tembusan"
                  hide-details
  
                  v-model="item.text"
                  :success="valid"
                  :error-messages="errors"
                  required
                  class="mb-6"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Tembusan {{ errors[0] }}
                      </v-tooltip>
                    </div>
  
                    <div v-if="item.text !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
  
            </v-card>
          </div>
        </v-col>
  
        <v-col
          cols="12"
          md="6">
          <v-card
            flat
            style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
            <div
              ref="arsippdf"
              style="padding: 50px;">
              <v-card-text
                class="black--text py-2">
                <div class="text-center font-weight_bold">
                  BERITA ACARA
                </div>
                <div class="text-center">
                  Nomor: {{ form.template_meta_json_object.nomor !== '' ? form.template_meta_json_object.nomor : '__________' }}
                </div>
                
                <div class="mt-4">
                  Pada hari ini, 
                  <span v-if="form.template_meta_json_object.hari_tanggal !== '' && form.template_meta_json_object.hari_tanggal !== null">
                    {{ form.template_meta_json_object.hari_tanggal | weekday }}
                  </span>

                  <span v-else>
                    __________
                  </span>
                  
                  ,

                  <span v-if="form.template_meta_json_object.hari_tanggal !== '' && form.template_meta_json_object.hari_tanggal !== null">
                    {{ form.template_meta_json_object.hari_tanggal | fulldate }}
                  </span>

                  <span v-else>
                    __________
                  </span>
                  , telah dilaksanakan {{ form.template_meta_json_object.acara !== '' ? form.template_meta_json_object.acara : '__________' }}, bertempat di {{ form.template_meta_json_object.tempat !== '' ? form.template_meta_json_object.tempat : '__________' }}, dengan rincian sebagai berikut:
                </div>

                <div
                  class="my-4"
                  style="margin-top: 16px !important; margin-bottom: 16px !important;">
                  <div
                    class="mb-4"
                    style="margin-bottom: 16px !important;">
                    <div class="mb-1 font-weight-bold">
                      1. Pembukaan
                    </div>
                    <v-row>
                      <v-col
                        cols="12"
                        md="3"
                        class="py-0 pr-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        Waktu
                      </v-col>

                      <v-col
                        cols="12"
                        md="9"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        : {{ form.template_meta_json_object.pukul !== '' ? form.template_meta_json_object.pukul : '__________' }}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="3"
                        class="py-0 pr-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        Pembukaan oleh
                      </v-col>

                      <v-col
                        cols="12"
                        md="9"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        : {{ form.template_meta_json_object.pembuka !== '' ? form.template_meta_json_object.pembuka : '__________' }}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="3"
                        class="py-0 pr-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        Keterangan
                      </v-col>

                      <v-col
                        cols="12"
                        md="9"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        : {{ form.template_meta_json_object.keterangan !== '' ? form.template_meta_json_object.keterangan : '__________' }}
                      </v-col>
                    </v-row>

                    <div class="mb-1 mt-4 font-weight-bold">
                      2. Daftar Hadir
                    </div>
                    <div>
                      <table style="border-collapse: collapse; width: 100%;">
                        <tr>
                          <th style="font-size: 13px; border: 1px solid #ddd; padding: 8px; text-align: center; width: 1px; white-space: nowrap;">
                            No
                          </th>
                          <th style="font-size: 13px; border: 1px solid #ddd; padding: 8px; text-align: center; width: 1px; white-space: nowrap;">
                            Nama
                          </th>
                          <th style="font-size: 13px; border: 1px solid #ddd; padding: 8px; text-align: center; width: 1px; white-space: nowrap;">
                            Jabatan
                          </th>
                          <th style="font-size: 13px; border: 1px solid #ddd; padding: 8px; text-align: center; width: 1px; white-space: nowrap;">
                            Perusahaan/Organisasi
                          </th>
                          <th style="font-size: 13px; border: 1px solid #ddd; padding: 8px; text-align: center; min-width: 100px;">
                            Tanda Tangan
                          </th>
                        </tr>

                        <tr v-for="(item, index) in form.template_meta_json_object.hadir" :key="index">
                          <td style="font-size: 12px; border: 1px solid #ddd; padding: 8px; text-align: center;">
                            {{ index + 1 }}
                          </td>
                          <td style="font-size: 12px; border: 1px solid #ddd; padding: 8px; text-align: left; width: 1px; white-space: nowrap;">
                            {{ item.nama }}
                          </td>
                          <td style="font-size: 12px; border: 1px solid #ddd; padding: 8px; text-align: left; width: 1px; white-space: nowrap;">
                            {{ item.jabatan }}
                          </td>
                          <td style="font-size: 12px; border: 1px solid #ddd; padding: 8px; text-align: left; width: 1px; white-space: nowrap;">
                            {{ item.unit }}
                          </td>
                          <td style="font-size: 12px; border: 1px solid #ddd; padding: 8px; text-align: left;">
                            
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div class="mt-4 mb-1 font-weight-bold">
                      3. Agenda Kegiatan
                    </div>
                    <div>
                      <ul>
                        <li v-for="(item, index) in form.template_meta_json_object.agenda" :key="index">
                          {{ item.text }}
                        </li>
                      </ul>
                    </div>
                    <div class="mt-4 mb-1 font-weight-bold">
                      4. Pembahasan
                    </div>
                    <div>
                      <ul>
                        <li v-for="(item, index) in form.template_meta_json_object.pembahasan" :key="index">
                          {{ item.text }}
                          <ul>
                            <li>
                              Pembicara: {{ item.pembicara }}
                            </li>
                            <li>
                              Ringkasan: {{ item.ringkasan }}
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                    <div class="mt-4 mb-1 font-weight-bold">
                      5. Kesimpulan
                    </div>
                    <div>
                      <ul>
                        <li v-for="(item, index) in form.template_meta_json_object.kesimpulan" :key="index">
                          {{ item.text }}
                        </li>
                      </ul>
                    </div>

                    <div class="mb-1 mt-4 font-weight-bold">
                      6. Penutup
                    </div>
                    <v-row>
                      <v-col
                        cols="12"
                        md="3"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        Waktu
                      </v-col>

                      <v-col
                        cols="12"
                        md="9"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        : {{ form.template_meta_json_object.pukul_tutup !== '' ? form.template_meta_json_object.pukul_tutup : '__________' }}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="3"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        Penutup oleh
                      </v-col>

                      <v-col
                        cols="12"
                        md="9"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        : {{ form.template_meta_json_object.penutup !== '' ? form.template_meta_json_object.penutup : '__________' }}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="3"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        Keterangan
                      </v-col>

                      <v-col
                        cols="12"
                        md="9"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        : {{ form.template_meta_json_object.keterangan_tutup !== '' ? form.template_meta_json_object.keterangan_tutup : '__________' }}
                      </v-col>
                    </v-row>
                  </div>
                </div>

                <v-row
                  justify="end"
                  class="mt-8"
                  style="display: flex; flex-wrap: wrap; flex: 1 1 auto; justify-content: flex-end !important; margin-top: 32px !important;">
                  <v-col
                    cols="12"
                    md="6"
                    class="text-center"
                    style="text-align: right !important;">
                    <div>
                      Yogyakarta, {{ form.template_meta_json_object.tanggal | fulldate }}
                    </div>
  
                    <div
                      class="mb-16"
                      style="margin-bottom: 64px !important;">
                      {{ form.template_meta_json_object.jabatan_1 !== '' ? form.template_meta_json_object.jabatan_1 : '__________' }}
                    </div>
  
                    <div>
                      {{ form.template_meta_json_object.nama_1 !== '' ? form.template_meta_json_object.nama_1 : '__________' }}
                    </div>
                  </v-col>
                </v-row>

                <div class="mt-4 mb-1 font-weight-bold">
                  Tembusan:
                </div>
                <div>
                  <ul>
                    <li v-for="(item, index) in form.template_meta_json_object.tembusan" :key="index">
                      {{ item.text }}
                    </li>
                  </ul>
                </div>
              </v-card-text>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </template>
  
  <script>
    import { get, post, put, destroy } from "@/service/Axios";
    import { TokenService } from "@/service/Storage.Service";
    import axios from "axios";
    import moment from "moment"
    import "moment/locale/id"
    import html2pdf from 'html2pdf.js'
    export default {
      props: {
        form: {
          type: Object,
          default: {}
        },
        units: {
          type: Array,
          default: []
        },
        process: {
          type: Object,
          default: {}
        }
      },
      data () {
        return {
          picker: {
            expired: false,
            tanggal: false,
            tanggal_mulai: false,
            tanggal_selesai: false,
            tanggal_masuk: false,
  
            range: false
          },
  
          time: {
            pukul: false,
            pukul_tutup: false
          },
        }
      },
      components: {
        
      },
      watch: {
  
      },
      computed: {
        user () {
          return this.$store.state.user
        },
        
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb_soft () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.2)`
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.2)`
        },
  
        configHeaders () {
          return this.headers.filter(header => !header.hide)  
        },
  
        // formattedDate: {
        //   get () {
        //     return (this.form.template_meta_json_object.tanggal && this.form.template_meta_json_object.tanggal.length === 10) ? moment(this.form.template_meta_json_object.tanggal).format('DD MMMM YYYY') : this.form.template_meta_json_object.tanggal
        //   },
        //   set (newValue) {
        //     if (newValue && newValue.length == 10) {
        //         let newDate = `${newValue.substring(6, 10)}-${newValue.substring(3, 5)}-${newValue.substring(0, 2)}`
        //         this.form.template_meta_json_object.tanggal = newDate
        //     }
        //   }
        // },
  
        date_range () {
          return this.filter.dates.join(' s/d ')
        }
      },
      mounted () {
        
      },
      methods: {
        formatPrice(value) {
          if (isNaN(value)) return "Not a Number"
          let number = ""
          const reverseNumber = value
            .toString()
            .split("")
            .reverse()
            .join("")
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]
          arrReverseNumber.map(index => {
            if (index % 3 === 0) number += reverseNumber.substr(index, 3) + "."
          })
  
          return `${
            number.split("", number.length - 1)
            .reverse()
            .join("")
          }`
        },
        add_agenda () {
          this.form.template_meta_json_object.agenda.push({
            text: ''
          })
        },
        add_pembahasan () {
          this.form.template_meta_json_object.pembahasan.push({
            text: '',
            pembicara: '',
            ringkasan: ''
          })
        },
        add_kesimpulan () {
          this.form.template_meta_json_object.kesimpulan.push({
            text: ''
          })
        },
        add_tembusan () {
          this.form.template_meta_json_object.tembusan.push({
            text: ''
          })
        },
      }
    }
  </script>
  